// reducers
import {
  TOGGLE_LOADING,
  FETCH_DASHBOARD_CONTENT,
  FETCH_ASSET_LIBRARY_HASHTAG_LIST,
  FETCH_ASSET_LIBRARY_CONTENT_LIST,
  FETCH_ASSET_CONTENT_DETAILS,
  FETCH_ASSET_LIBRARY_FOLDER_LIST,
  FOLDER,
  UNAUTHORIZED_ASSET_LIBRARY,
  FETCH_ASSET_FOLDER_DROPDOWN_LIST,
  ADD_CONTENT_TO_FOLDER,
  SET_ASSET_LIBRARY_CATEGORY_FILTER,
  DEALROOM_SWITCH,
  DEBUGGER_MODE
} from "../../constants/AssetLibActionTypes";

const initialState = {
  loading: false,
  debugger_mode: "false",
  dealRoomSwitch: false,
  userData: null,
  folderList: [],
  categoryList: [],
  hashtagList: [],
  contentList: [],
  currentAssetDetails: [],
  list: [],
  folderId: null,
  unauthorizedAssetLibrary: null,
  folderDropdown: [],
  addFolder: null,
  categoryId: null,
};

const assetLibReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TOGGLE_LOADING:
      return { ...state, loading: payload };
    case FETCH_DASHBOARD_CONTENT:
      return {
        ...state,
        userData: payload.user_data,
        folderList: payload.folders,
        categoryList: payload.categories,
      };
    case FETCH_ASSET_LIBRARY_HASHTAG_LIST:
      return {
        ...state,
        hashtagList: payload,
      };
    case FETCH_ASSET_LIBRARY_CONTENT_LIST:
      return {
        ...state,
        contentList: payload,
      };
    case FETCH_ASSET_CONTENT_DETAILS:
      return { ...state, currentAssetDetails: payload };
    case FETCH_ASSET_LIBRARY_FOLDER_LIST:
      return {
        ...state,
        folderList: payload,
      };
    case FOLDER:
      return {
        ...state,
        folderId: payload,
      };
    case SET_ASSET_LIBRARY_CATEGORY_FILTER:
      return {
        ...state,
        categoryId: payload,
      };
    case UNAUTHORIZED_ASSET_LIBRARY:
      return { ...state, unauthorizedAssetLibrary: payload };
    case FETCH_ASSET_FOLDER_DROPDOWN_LIST:
      return { ...state, folderDropdown: payload };
    case DEBUGGER_MODE:
        return { ...state, debugger_mode: payload };
    case ADD_CONTENT_TO_FOLDER:
      return { ...state, addFolder: payload };
    case DEALROOM_SWITCH:
      return { ...state,dealRoomSwitch: payload };
    default:
      return state;
  }
};
export default assetLibReducer;
